import React, { useState, useEffect, useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import styles from './Stats.module.css';

const Stats = () => {
  const [animatedValues, setAnimatedValues] = useState({
    clients: 0,
    years: 0,
    documents: 0,
    support: 0
  });

  const [hasAnimated, setHasAnimated] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  const stats = useMemo(() => [
    { id: 'clients', value: 5200, suffix: '+', label: 'Довольных клиентов', icon: 'fas fa-users' },
    { id: 'years', value: 8, suffix: '+', label: 'Лет на рынке', icon: 'fas fa-calendar-alt' },
    { id: 'documents', value: 15000, suffix: '+', label: 'Выданных документов', icon: 'fas fa-file-invoice' },
    { id: 'support', value: 24, suffix: '/7', label: 'Поддержка', icon: 'fas fa-headset' }
  ], []);

  useEffect(() => {
    if (inView && !hasAnimated) {
      setHasAnimated(true);
      
      stats.forEach(stat => {
        const targetValue = stat.value;
        let currentValue = 0;
        const increment = targetValue / 50;
        const interval = 20;

        const timer = setInterval(() => {
          currentValue += increment;
          if (currentValue >= targetValue) {
            currentValue = targetValue;
            clearInterval(timer);
          }
          
          setAnimatedValues(prev => ({
            ...prev,
            [stat.id]: Math.round(currentValue)
          }));
        }, interval);
      });
    }
  }, [inView, hasAnimated, stats]);

  const reviews = [
    {
      id: 1,
      text: 'Заказывал чеки для командировки в Москве. Сделали все быстро, качественно, конфиденциально. Очень выручили, когда потерял оригиналы документов.',
      author: 'Александр К.',
      position: 'Менеджер по продажам',
      rating: 5
    },
    {
      id: 2,
      text: 'Работаем с компанией уже более 3 лет. Всегда оперативно помогают с документами для отчетности. Чеки проходят любые проверки.',
      author: 'Ольга Смирнова',
      position: 'Главный бухгалтер',
      rating: 5
    },
    {
      id: 3,
      text: 'Обращался за срочным изготовлением чеков. Сделали за 2 часа, доставили в офис. Профессионально и надежно. Рекомендую!',
      author: 'Дмитрий П.',
      position: 'Директор компании',
      rating: 5
    }
  ];

  return (
    <section className={`section ${styles.stats}`} ref={ref}>
      <div className="container">
        <div className={styles.statsContent}>
          <div className={styles.statsHeader}>
            <h2 className="section-title">
              МЫ В <span className="section-title--accent">ЦИФРАХ</span>
            </h2>
            <p className="section-subtitle">
              За годы работы мы заслужили доверие тысяч клиентов по всей Москве
            </p>
          </div>

          <div className={styles.statsGrid}>
            {stats.map((stat) => (
              <div key={stat.id} className={`card ${styles.statCard}`}>
                <div className={styles.statIcon}>
                  <i className={stat.icon}></i>
                </div>
                <div className={styles.statValue}>
                  {animatedValues[stat.id]}
                  <span className={styles.statSuffix}>{stat.suffix}</span>
                </div>
                <div className={styles.statLabel}>{stat.label}</div>
              </div>
            ))}
          </div>

          <div className={styles.reviewsSection}>
            <div className={styles.reviewsHeader}>
              <h3 className={styles.reviewsTitle}>
                <i className="fas fa-star"></i>
                ОТЗЫВЫ КЛИЕНТОВ
              </h3>
              <p className={styles.reviewsSubtitle}>
                Что говорят наши клиенты о сотрудничестве
              </p>
            </div>

            <div className={styles.reviewsGrid}>
              {reviews.map((review) => (
                <div key={review.id} className={`card ${styles.reviewCard}`}>
                  <div className={styles.reviewRating}>
                    {[...Array(review.rating)].map((_, i) => (
                      <i key={i} className="fas fa-star"></i>
                    ))}
                  </div>
                  <p className={styles.reviewText}>"{review.text}"</p>
                  <div className={styles.reviewAuthor}>
                    <div className={styles.authorInfo}>
                      <div className={styles.authorName}>{review.author}</div>
                      <div className={styles.authorPosition}>{review.position}</div>
                    </div>
                    <div className={styles.authorIcon}>
                      <i className="fas fa-user-circle"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className={styles.trustBadge}>
            <div className={styles.trustContent}>
              <div className={styles.trustIcon}>
                <i className="fas fa-shield-alt"></i>
              </div>
              <div>
                <h3 className={styles.trustTitle}>ДОВЕРИЕ И НАДЕЖНОСТЬ</h3>
                <p className={styles.trustText}>
                  Мы ценим доверие наших клиентов и гарантируем полную конфиденциальность 
                  всех операций. Каждый документ — это 100% гарантия качества.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;